import { Alert } from 'antd';
import { useTranslation } from 'react-i18next';

const WarningMessage = () => {
  const { t } = useTranslation('common');

  return (
    <Alert
      showIcon
      description={t('warningMessage')}
      message={t('warning')}
      type="warning"
    />
  );
};

export default WarningMessage;
